import { render, staticRenderFns } from "./RealTimeSelectAreaComponent.vue?vue&type=template&id=2facaf51&"
import script from "./RealTimeSelectAreaComponent.vue?vue&type=script&lang=js&"
export * from "./RealTimeSelectAreaComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
